import { useState } from 'react';

import { PageHead } from 'ui/components/PageHead';
import { GlossaryItem } from 'ui/pages/GlossaryPage/GlossaryItem';
import { Seo } from '__generated__/graphql';

import { GlossaryFilters } from './GlossaryFilters';
import {
  GlossaryPageHeader,
  GlossaryPageHeaderProps,
} from './GlossaryPageHeader';

export type GlossaryPageProps = {
  page:
    | {
        header: GlossaryPageHeaderProps;
        seo: Seo;
      }
    | undefined;
  terms: GlossaryItem[];
};

const GlossaryPageHead = ({ page }: Pick<GlossaryPageProps, 'page'>) => {
  if (!page) return null;
  return (
    <>
      <PageHead
        title={page?.seo?.pageTitle}
        description={`${page?.seo?.pageDescription}`}
      />
      <GlossaryPageHeader {...page.header} />
    </>
  );
};

export const GlossaryPage = ({ page, terms }: GlossaryPageProps) => {
  const [filteredTerms, setFilteredTerms] = useState(terms);
  return (
    <>
      <GlossaryPageHead page={page} />
      <GlossaryFilters
        terms={terms}
        filteredTerms={filteredTerms}
        setFilteredTerms={setFilteredTerms}
      />
      {filteredTerms
        .slice()
        .sort((a, b) => a.puid.localeCompare(b.puid))
        .map((term, index) => (
          <GlossaryItem
            key={term.puid}
            alignment={index % 2 === 0 ? 'left' : 'right'}
            {...term}
          />
        ))}
    </>
  );
};
